import { getCookie, setCookie } from '../../../utils/cookies'
import '../../../modules/scroll-events/v1/scroll-events'

const displayed_styles = []

$.fn.Popup = function(options) {
  let self = this

  if (self.data('popup')) {
    return self.data('popup')
  }

  if (options == undefined) {
    options = {}
  }

  self.options = $.fn.extend(true, {
    click_outside: true,
  }, options)

  self.el = {
    close_btn: self.find('.featured-message__close')
  }

  self.style = self.data('style')
  self.has_been_displayed = false
  self.scroll_events = $(window).ScrollEvents()

  self.display = function() {
    self.scheduled = true
    self.schedule = JSON.parse(self.attr('data-schedule'))
    if (self.schedule.schedule_preset == 'scheduled') {
      let today = new Date(),
      start = new Date(self.schedule.start.replace(' ', 'T')),
      end = new Date(self.schedule.end.replace(' ', 'T'))
      if (start > today || end < today) {
        self.scheduled = false
      }
    }
    if (!self.has_been_displayed && self.scheduled && !displayed_styles.includes(self.style)) {
      self.attr('aria-hidden', 'false')
      $(window).trigger('message_displayed', [self])
      displayed_styles.push(self.style)
      self.has_been_displayed = true
      if ('dismiss_preset' in self.data('dismiss')) {
        if (self.data('dismiss').dismiss_preset == 'auto_hidden_delay') {
          self.dismiss_with_delay()
        }
      }
    }
  }

  self.dismiss_with_delay = function() {
    let dismiss_delay = parseFloat(self.data('dismiss').duration)
    if (self.data('dismiss').unit == 'minutes') {
      dismiss_delay *= (60)
    } if (self.data('dismiss').unit == 'hours') {
      dismiss_delay *= (60 * 60)
    } else if (self.data('dismiss').unit == 'days') {
      dismiss_delay *= (60 * 60 * 24)
    }
    if (dismiss_delay > 0) {
      setCookie('message-dismissed_' + self.style, 'yes', dismiss_delay)
    }
  }

  self.close = function() {
    self.attr('aria-hidden', 'true')
    $(window).trigger('message_dismissed', [self])
    if ('dismiss_preset' in self.data('dismiss')) {
      if (self.data('dismiss').dismiss_preset == 'dismiss_hidden_delay') {
        self.dismiss_with_delay()
      }
    }
  }

  self.initialize_cookie = function() {
    if (getCookie('message-dismissed_' + self.style) == 'yes') {
      self.has_been_displayed = true
    }
  }

  self.initialize_popup = function() {
    self.el.close_btn.on('click', self.close)
    self.on('click', function(e) {
      if (self.options.click_outside && e.target == self.get(0)) {
        self.close()
      }
    })
  }

  self.initialize_trigger = function() {
    if (self.data('settings') && 'appear_preset' in self.data('settings')) {
      /* appears on page load */
      if (self.data('settings').appear_preset == 'page_load') {
        self.display()
      }

      /* appears after delay (page) */
      if (self.data('settings').appear_preset == 'after_seconds') {
        let milliseconds = parseFloat(self.data('settings').seconds) * 1000
        setTimeout(self.display, milliseconds)
      }

      /* appears after scroll percentage */
      if (self.data('settings').appear_preset == 'after_scroll') {
        let scroll_percentage = parseFloat(self.data('settings').scroll) / 100
        self.scroll_events.add(function(top, direction) {
          if (self.has_been_displayed == false) {
            let max_scroll = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight)
            if (direction == 'down' && top >= max_scroll * scroll_percentage) {
              self.display()
            }
          }
        })
      }
    }
  }

  return function() {
    self.initialize_cookie()
    self.initialize_popup()
    self.initialize_trigger()
    self.data('popup', self)
    return self
  }()
}

export default {
  get(style) {
    return $('.featured-message--style-' + style).data('popup')
  },

  init(options) {
    if (options == undefined) {
      options = {}
    }
    $('.featured-message').each(function() {
      $(this).Popup(options)
    })
  },
}
